import React, { memo, useId } from 'react'

import { number, oneOfType, shape, string } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { STUDIO_ACCESS_TIER } from 'Pods/ThreeDStudio/Store/constants'

import SlotsNotice from './Components/SlotsNotice/SlotsNotice'
import UpgradeNotice from './Components/UpgradeNotice/UpgradeNotice'
import useDisplayPhase from './useDisplayPhase'
import useProgressPercent from './useProgressPercent'

// Phase title, hardcoded time-left copy, and the phase-mapped progress bar for the
// watched in-flight run, plus the plan-aware notice below it.
function GenerationProgress({ run = null }) {
  const t = useTranslation()
  const titleId = useId()
  const phase = useDisplayPhase(run)
  const percent = useProgressPercent(phase, run)
  const studioAccessTier = useThreeDStudioStore(state => state.subscription.studioAccessTier)
  const concurrencyCap = useThreeDStudioStore(state => state.subscription.concurrencyCap)
  const multipleGenerationsEnabled = useThreeDStudioStore(
    state => state.subscription.multipleGenerationsEnabled
  )
  const hasSubscribedPlan = studioAccessTier === STUDIO_ACCESS_TIER.SUBSCRIBED
    || (multipleGenerationsEnabled && concurrencyCap != null)

  return (
    <div className="generation-progress">
      <div className="generation-progress__meter">
        <div className="generation-progress__status" aria-live="polite">
          <p id={titleId} className="generation-progress__title cgt-heading-200">
            {t(`viewer.banner.phase.${phase}`)}
          </p>
          <p className="generation-progress__subtitle cgt-body-base">
            {t(`viewer.banner.phaseTimeLeft.${phase}`)}
          </p>
        </div>
        <div
          className="generation-progress__track"
          role="progressbar"
          aria-valuemin={0}
          aria-valuemax={100}
          aria-valuenow={Math.round(percent)}
          aria-labelledby={titleId}
        >
          <div className="generation-progress__fill" style={{ width: `${percent}%` }} />
        </div>
      </div>
      {hasSubscribedPlan ? <SlotsNotice /> : <UpgradeNotice />}
    </div>
  )
}

GenerationProgress.propTypes = {
  run: shape({
    phase: string,
    startedAt: number,
    phaseUpdatedAt: oneOfType([number, string]),
  }),
}

export default memo(GenerationProgress)
